import React from "react";
import { InputLabel } from "Components/Base/Inputs/InputLabel";
import { MenuItem } from "Components/Base/Inputs/MenuItem";
import { Select } from "Components/Base/Inputs/Select";
import { Box } from "Components/Base/Layout/Box";

/**
 * En komponent för ett etikettvald-rullgardinsmeny.
 *
 * @component
 * @example
 * const id = "minInput";
 * const label = "Välj ett alternativ";
 * const onChange = (event) => console.log(event.target.value);
 * const selectValue = "alternativ1";
 * const menuItems = [
 *   { value: "alternativ1", title: "Alternativ 1" },
 *   { value: "alternativ2", title: "Alternativ 2" },
 *   { value: "alternativ3", title: "Alternativ 3" },
 * ];
 * const defaultMenuItem = { value: "default", title: "Välj ett alternativ" };
 *
 * <InputLabelSelect
 *   id={id}
 *   label={label}
 *   onChange={onChange}
 *   selectValue={selectValue}
 *   menuItems={menuItems}
 *   defaultMenuItem={defaultMenuItem}
 * />
 *
 * @param {object} props - Egenskaper för komponenten.
 * @param {string} props.id - Unik identifierare för komponenten (valfri).
 * @param {string} props.label - Etiketten för rullgardinsmenyn.
 * @param {function} props.onChange - Funktionen som anropas vid ändring av värde.
 * @param {string} props.selectValue - Det aktuella valda värdet.
 * @param {Array} props.menuItems - En array av objekt som representerar menyalternativen.
 * @param {object} props.defaultMenuItem - Det förvalda menyalternativet (valfritt).
 * @param {boolean} props.autoWidth - Om man vill ändra bredden på textfielden (valfritt).
 * @param {number} props.minwidth - Om man vill ändra bredden på textfielden (valfritt).
 * @returns {JSX.Element} - En JSX-elementrepresentation av komponenten.
 */
const InputLabelSelect = ({
  id = "InputLabelSelect-",
  label,
  onChange,
  selectValue,
  menuItems,
  defaultMenuItem,
  autoWidth,
  minwidth,
  fullWidth,
  maxWidth,
  labelClassName,
  autoFocus,
}) => (
  <Box maxWidth={maxWidth}>
    <Box mb={1} width="fit-content">
      <InputLabel id={`${id}Label`} htmlFor={id} className={labelClassName}>
        {label}
      </InputLabel>
    </Box>
    <Select
      labelId={`${id}Label`}
      id={id}
      value={selectValue}
      onChange={(event) => onChange(event)}
      variant="outlined"
      autoWidth={autoWidth}
      fullWidth={fullWidth}
      minwidth={minwidth}
      autoFocus={autoFocus}
      maxWidth={maxWidth}
    >
      {defaultMenuItem && (
        <MenuItem value={defaultMenuItem.value}>
          {defaultMenuItem.title}
        </MenuItem>
      )}
      {menuItems &&
        menuItems.map((menuItem, index) => (
          <MenuItem key={menuItem.title + index} value={menuItem.value}>
            {menuItem.title}
          </MenuItem>
        ))}
    </Select>
  </Box>
);

export default InputLabelSelect;
